import api from "@ignite/api"
import { useQuery } from "@tanstack/react-query"

export const useGetSiteSettings = () =>
  useQuery([`siteSettings`], api.siteSettings.get, {
    select: (settings) => ({
      ...settings.properties,
    }),
  })
